import {Button, Layout, Menu, Popup, Spacer} from '@di-nxt/components';
import React from 'react';
import {SceneHeader} from '../../../components';
import {t} from '../../../localization';
import {ScheduleCalendarType} from '../../../services';
import {useAddOrEditAbsenceTask} from '../../modals/absence';
import {ScheduleTypeSelector} from './CalendarTypeSelector';

type Props = {
  teamId: number;
  calendarType: ScheduleCalendarType;
  onCalendarTypeChange: (type: ScheduleCalendarType) => void;
};

export const ScheduleSceneHeader: React.FC<Props> = ({
  teamId,
  calendarType,
  onCalendarTypeChange,
}) => {
  const registerAbsence = useAddOrEditAbsenceTask(teamId);

  return (
    <SceneHeader title={t('screens.schedule.title')}>
      <Layout flex horizontal>
        <Layout flex horizontal justify="flex-end">
          <ScheduleTypeSelector
            calendarType={calendarType}
            onCalendarTypeChange={onCalendarTypeChange}
          />
        </Layout>
        <Layout centered>
          <Spacer width="10" />
          <Popup
            trigger={
              <Button kind="Primary" leftIcon="plus" size="Small" round />
            }>
            {closePopup => (
              <Menu
                items={[t('screens.schedule.absencedialog.titles.add')]}
                icons={['absence']}
                onChange={index => {
                  closePopup();
                  if (index === 0) {
                    registerAbsence();
                  }
                }}
              />
            )}
          </Popup>
        </Layout>
      </Layout>
    </SceneHeader>
  );
};
